import NewTooltip from '@seller-hermes/features/ui/NewTooltip/tooltip.component';

export const Tooltip = NewTooltip;

export default NewTooltip;
